var _a, _b;
import ReactLib from 'react';
import ReactDOMLib from 'react-dom';
import App from '@elevio/kb-kit/lib/App';
import config from './config';
import './css/main.css';
const React = ((_a = ReactLib.default) !== null && _a !== void 0 ? _a : ReactLib);
const ReactDOM = ((_b = ReactDOMLib.default) !== null && _b !== void 0 ? _b : ReactDOMLib);
if (process.env.NODE_ENV !== 'production') {
    import('@axe-core/react').then((axe) => {
        axe.default(React, ReactDOM, 1000);
    });
}
const target = document.getElementById('kb-target');
if (!target)
    throw new Error('Cant find target div');
ReactDOMLib.render(<App config={config}/>, target);
